module.exports = {
    title: "东风日产供应链合作伙伴大会服务平台",
    menu: {
        menu: "首页",
        guest: "参会须知",
        agenda: "大会日程",
        meetingS: "用餐查询",
        new: "新车品鉴",
        new1: "新车品鉴问卷调查",
        live: "现场直播",
        photo: "精彩时刻",
        investigation: "问卷调查",
        meetingL: "会议资料",
        contact: "联系我们",
        service: '接送服务',
    },
    menuCn: {
        menu: "首页",
        guest: "参会须知",
        agenda: "大会日程",
        meetingS: "会议查询",
        photo: "图片视频",
        investigation: "问卷调查",
        meetingL: "会议资料",
        contact: "联系我们"
    },
    welcome: {
        welcome: "欢迎",
        signOut: "退出"
    },
    login: {
        code: "请输入验证码",
        phone: "请输入手机号",
        country: "国际手机号码",
        getCode: "获取验证码",
        loginBtn: "登　录",
        title: "验证信息",
    },
    tips: {
        phone_type: "仅支持中国大陆地区的号码",
        phone: "请输入您的手机号",
        phone_err: "手机号格式不正确",
        code: "请输入您的验证码",
        code_err: "验证码不正确",
        code_success: "验证码发送成功",
        code_error2: "请完善信息",
        loginPlease: "请先登录",
        loginSuccess: "登录成功",
        completePlease: "请先完善信息",
        tips1: "温馨提示",
        tips2: "确认",
        l_tips1: "未查询到您的信息",
        l_tips11: "用户不存在",
        l_tips2: "验证码有误",
        l_tips3: "参数错误",
        l_tips4: "请勿重复提交",
        l_tips5: "授权失败",
        l_tips6: "发送频繁",
    },
    back: {
        waiting: "敬请期待!",
        welcome: "欢迎您，",
        login_err: "登录失效",
        sure: "确认",
        cancle: "取消",
        success: "提交成功",
        success_text1: "您的信息已经",
        success_text2: "提交成功！",
        btn: "查看会议信息",
        title: "东风日产供应商年会服务平台",
        close: "功能已关闭！"
    },
    guest: {
        title: "参会须知",
        menu1: "签到须知",
        menu2: "人脸识别",
        menu3: "同传须知",
        menu4: "酒店地图",
        menu5: "退房须知",
        menu55: '',
        menu6: "发票领取",
        signin: {
            title: "签到须知",
            title1: "签到时间及地点：",
            date1: "2024年12月25日",
            time1: " 12:00-24:00",
            time2: " 广州番禺长隆酒店大堂",
            time22: "",
            date2: "2024年12月26日",
            time3: " 08:00-13:00",
            time4: "住宿嘉宾：广州番禺长隆酒店大堂",
            time44: "非住宿嘉宾：广州番禺长隆国际会展中心",
            time444: "长隆国际会展中心旁停车场",
            place1: "签到联系人（可直接拨打）",
            place11: "送机/站联系人（可直接拨打）",
            title2: "签到流程：",
            procedure1: '参会嘉宾通过人脸识别或手机号签到，确认信息，领取房号、嘉宾证，再前往酒店前台录入证件信息，领取房卡，签到入住办理完成。',
            title3: "接机提醒：",
            tips11: "1、接机/站时间：<br>12月18日 12:00-24:00<br>12月19日 07:00-12:00",
            tips1: "2、我们在广州白云机场、广州北火车站均安排接机站服务,将在出口举“东风日产”指示牌等候您，请跟随工作人员前往乘车。",
            tips2: "3、广州白云机场联系人（可直接拨打）：周裕 ",//137 1463 8120
            tips3: "广州北火车站联系人（可直接拨打）：刘淑仪",
            contact: {
                name: "长隆酒店大堂：熊娟",
                name1: "国际会展中心：刘婷",
            },
        },
        face: {
            title: "人脸识别",
            tips1: "1、大会全面采用人脸识别系统。会议报到、会议期间出入会场、餐厅、新车品鉴等均采用人脸识别，您仅需将面部对准人脸识别摄像头即可；",
            tips2: "2、嘉宾证仅作为参会嘉宾出入会场、餐厅的补充备用凭证，请全程佩戴，请勿转借他人使用;",
        },
        earphone: {
            title: "同传须知",
            tips_title: "同传使用说明：",
            tipss: '特别提醒：会议结束后，请在会场外“同传回收处”归还同传设备（系统核销），如有遗失或损坏，会务组将追溯赔偿。',
            step1: "第一步:",
            tips1: "将耳机插入红外接收机的耳机插孔中",
            step2: "第二步:",
            tips2: "将红外接收机电源开关打开（注意：不插耳机，电源打不开）",
            step3: "第三步:",
            tips3: "循环调节调频按钮，选择有声音的“频率”，然后根据自己所需调节音量大小，若以上操作完成，仍然不能接收到声音，请到会场外，将有工作人员为您解决。",
        },
        hotel: {
            title: "酒店地图",
            tips1: "酒店平面图",
            tips2: "会场内平面图",
            tips3: '酒店群平面图',
            title1: "广州施柏阁大观酒店1F",
            title2: "广州施柏阁大观酒店2F",
            title3: "广州融创施柏阁酒店",
        },
        out: {
            title: "退房须知",
            tips1: {
                title: "退房须知",
                one: "1、请您根据您退房日期，于当天12:00前将房卡退至酒店前台；",
                two: "2、如需延长住宿时间，请提前到酒店大堂签到处办理延房手续，否则酒店会按照您的计划退房时间清理房间；当天18:00前退房加收半天房费，18:00后退房加收一天房费；",
                three: "3、酒店住宿费用是根据您报名住宿需求预定支付费用的，如您选择提前退房，住宿费用将无法退还；",
                three11: "4、以下费用需要您到前台自行结算：",
                three1: "①酒店房间物品损坏；",
                three2: "②酒店其他消费；",
                three3: "③酒店房卡遗失需赔偿50元/张。",
                four: "5、如您退房后发现有物品遗留在酒店客房，请与签到处负责人联系",
                four1: "熊娟"
            },
            tips2: {
                title: "发票领取",
                tips1: "开票时间",
                tips2: "2024年12月25日报到办理入住后，至12月27日离店前；",
                tips3: "开票方式",
                tips4: "凭收据在长隆酒店前台换取发票；酒店使用电子发票，通过邮件方式发送，如需代开请提供对应收据。",
            },
            tips3: {
                title: "特别提醒",
                one: "为避免退房高峰期申请发票等候时间过长，请您在离店前的空余时间前往开票。",
                two: "若嘉宾因特殊原因无法及时申请发票，可提前联系签到处工作人员(",
                three: ')登记处理，后续通过电子邮件发送发票。',
            },
        },
        timetable: {
            title: "接送服务",
            title1: "接机须知",
            place1: {
                name: "广州番禺长隆酒店 - 广州白云国际机场",
                time1: "06:00　07:00　07:30　08:00　08:30",
                time2: "09:00　10:00　11:00　12:00　13:00　14:00"
            },
            place2: {
                name: "广州番禺长隆酒店 - 广州南火车站",
                time1: "08:00　09:00　10:00　11:00",
                time2: "12:00　13:00　14:00",
            },
            tips1_title: "12月27日送机/站发车时刻表",
            contact: {
                name: "广州白云机场联系人（可直接拨打）：周裕",
                name1: "广州南火车站联系人（可直接拨打）：叶趣焕",
                name2: "周裕",
            },
            place: {
                title: "集合地点",
                name: "广州番禺长隆酒店大堂"
            },
            tips: {
                title: "温馨提示：",
                one: "1、酒店至广州白云国际机场约70分钟车程，建议航班起飞前3.5小时从酒店乘车出发",
                two: "2、酒店至广州南火车站约30分钟车程，建议火车发车前2小时从酒店乘车出发。",
                three: "特别提醒:",
                four: "为确保乘车嘉宾能准时抵达机场/火车站，每趟巴士将严格按照上述时间发车。",
                five: '抵达广州南火车站后，请前往东广场问讯处集合',
                six: '1、广州白云机场、广州南火车站均安排接机站服务，将在出口举”东风日产"指示牌等候您，请跟随工作人员前往乘车。',
                seven: '2、接站/机时间：',
                seven1: '12月25日 12:00-24:00',
                seven2: '12月26日 08:00-12:00',
                eight1: '广州白云机场联系人（可直接拨打）：周裕',
                eight2: '广州南火车站联系人（可直接拨打）：叶趣焕',
            }
        }
    },
    agenda: {
        title: "大会日程",
    },
    meetingS: {
        title: "会议查询",
        menu1: "主题分会查询",
        menu2: "工作宴会查询",
        theme: {
            title: "主题分会查询",
            title1: "主题分会",
            tips: "您将要参加的主题分会",
            tips1: "将要参加的主题分会",
            thead: {
                td1: "日期",
                td2: "品鉴时间预约",
                td22: "剩余名额",
                td3: "地点",
                td4: "座位",
            },
            date: "12月26日",
            none: '无',
            meet: "MEET大讲堂",
            meet_place: "会展中心宴会厅",
            g30: "G30核心供应商峰会",
            g30_place: "会展中心宴会厅",
            finance: "财务分会",
            finance_place: "国际会展中心 3F 321",
            btn: "查询",
            placeholder: "请输入嘉宾的姓名或手机号",
            map_text: "大会座位区域图",
            areaName: "区",
            query_tips: "请选择品鉴时间预约",
            query_tips1: "请输入嘉宾姓名",
            query_tips_none: "没有查询到信息"
        },
        yhquery: {
            title: "工作宴会查询",
            query_tips: "请输入嘉宾姓名",
            thead: {
                td1: "姓名",
                td2: "时间/地点",
                td3: "桌号"
            },
            results: "查询结果",
            guest: "同桌嘉宾"
        },
    },
    meetingL: {
        file1: "技术中心报告",
        file2: "采购总部报告",
        file3: "品质部门报告",
        file4: "供应链管理部门报告",
        file5: "市场销售总部报告",
        file6: "东风启辰报告",
        file7: "东风英菲尼迪报告",
        tips1: "可点击图片放大",
        loading: "正在加载"
    },
    photo: {
        title: "精彩时刻",
        menu1: "大会照片",
        menu2: "视频集锦",
        menu3: "赠言大会"
    },
    investigation: {
        title: "参会满意度调查表",
        user: "尊敬的嘉宾：",
        tips: "感谢您参加东风日产乘用车公司2024年供应链合作伙伴大会，我们十分珍视您的反馈意见，在此请您用一点时间填写这份调查问卷。本次调查采用匿名形式，希望您根据实际参会体验填写，您的宝贵意见将有助于我们提供更好的会议服务。",
        select1: "A  満足",
        select2: "B  普通",
        select3: "C  不満足",
        question1: "1、您对本次合作伙伴大会的整体安排：",
        question2: "2、您对本次酒店住宿及餐饮安排：",
        question3: "3、您对本次会议报到及入住办理效率：",
        question4: "4、您对接送机时间安排、服务态度（未选择接送机服务可不填写）：",
        question5: "5、您对在线报名系统：",
        question6: "6、您对微信公众号的使用及功能：",
        question7: "7、您对参会指引及咨询友好性：",
        question8: "8、您对大会主题、议程及内容：",
        question9: "9、您对会务组全体工作人员服务评价：",
        question10: "10.您对本次合作伙伴大会的其他意见及建议：",
        thanks: "谢谢您的支持！",
        btn: "提交",
        success: "谢谢您的反馈！",
        already: "您之前已反馈，请勿重复提交。",
    },
    investigation1: {
        tips: "评分规则：1~2分-非常难看，3～4分-比较不喜欢，5～6分-一般喜欢，7～8分-比较喜欢，9～10分-非常喜欢",
        question1: "1、外观：",
        question2: "2、内饰：",
        question3: "3、您觉得要N7 大卖，我们可以做哪些工作？ 请写出您具体对产品/售价/营销/宣传/服务等方面具体活动的想法。",
        placeholder: '请您提具体的"槽点"，以便我们努力完善',
        question1Arr: [{
            name: '【前端造型】',
            val: 'q1'
        }, {
            name: '【侧面造型】',
            val: 'q2'
        }, {
            name: '【后端造型】',
            val: 'q3'
        }, {
            name: '【整体外观造型】',
            val: 'q4'
        }, {
            name: '【您喜欢的车身颜色，请填写2-3种】',
            val: 'q5',
            type: 'input'
        }],
        question2Arr: [{
            name: '【中控/仪表台】',
            val: 'q6'
        }, {
            name: '【四门内饰板】',
            val: 'q7'
        }, {
            name: '【中央扶手设计】',
            val: 'q8'
        }, {
            name: '【座椅设计】',
            val: 'q9'
        }, {
            name: '【空间/舒适度】',
            val: 'q10'
        }, {
            name: '【整体内饰】',
            val: 'q11'
        }, {
            name: '【您喜欢的内饰颜色，请填写2-3种】',
            val: 'q12',
            type: 'input'
        }],
        thanks: "谢谢您的支持！",
        btn: "提交",
        success: "谢谢您的反馈！",
        already: "您之前已反馈，请勿重复提交。",
        required_tip: "请为{name}打分",
        reason_required_tip: "请您提具体的”槽点，以便我们努力完善",
        suggestion_required: "您觉得要N7 大卖，我们可以做哪些工作？",
        submit_success: "提交成功",
        submit_error: "提交失败，请稍后重试",
    },
    contact: {
        tips: "会议期间，如有疑问，请联系以下人员：",
        thead: {
            td1: "会务主管",
            td2: "姓名",
            td3: "电话号码",
            td4: "",
        },
        job: "",
        job1: "",
        tbody: {
            line1: {
                job: "总协调",
                name: "朱俊",
                name1: "邓红梅",
            },
            line2: {
                job: "大会咨询",
                name: "陈菁"
            },
            line3: {
                job: "内部协调",
                name: "岳宇"
            },
            line4: {
                job: "会场总控",
                name: "许文凯",
                name1: "陈伟龙"
            },
            line5: {
                job: "车辆协调",
                name: "邓红梅"
            },
        }
    },
    video: "视频-",
    say: {
        title: '赠言大会',
        bth: '输入赠言',
        placeholder: '20文字以内',
        tips: '输入赠言',
    },
};


// WEBPACK FOOTER //
// ./src/i18n/zh.js